import { LOCATION_CHANGE } from 'ContentEditorUI/redux/actions/actionTypes';
import { TAB_CONTENT } from 'EmailEditorUI/constants/SidebarConstants';
import { SELECT_ELEMENT, UPDATE_SIDEBAR_TAB } from 'EmailEditorUI/redux/actions/IframeSyncedActionTypes';
const INITIAL_STATE = {
  mainTab: TAB_CONTENT,
  subTab: ''
};
const sidebarTab = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case UPDATE_SIDEBAR_TAB:
      return {
        mainTab: action.tabName,
        subTab: action.subTabName || ''
      };
    case SELECT_ELEMENT:
    case LOCATION_CHANGE:
      return INITIAL_STATE;
    default:
      return state;
  }
};
export default sidebarTab;